export const getWeekDay = (date?: string) => {
  if (!date) return 'undefined date';
  const weekDay = new Date(date).getUTCDay();
  if (weekDay < 0 || weekDay > 6) return 'invalid weekday';
  const transtaledWeekdays = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'];
  return transtaledWeekdays[weekDay];
};
